"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOBILE_POPUP_OPTIONS = exports.CLOSE_BUTTON_TEXT = void 0;
var _localization = require("@lt/localization");
var CLOSE_BUTTON_TEXT = exports.CLOSE_BUTTON_TEXT = _localization.i18n.t('hotel.filters.closeButton');
var MOBILE_POPUP_OPTIONS = exports.MOBILE_POPUP_OPTIONS = {
  showCloseIcon: false,
  closeOnOverlayClick: false,
  center: false
};